var exports = {
  "q": "xdde3148b--b53416--features",
  "p": "xdde3148b--b53416--list",
};

module.exports = exports;
